import { render } from "./AddMeal.vue?vue&type=template&id=43ec3358"
import script from "./AddMeal.vue?vue&type=script&lang=js"
export * from "./AddMeal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__